module.exports = __webpack_public_path__ + "static/img/LS.50cbdded.png";